import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Canvas } from "@react-three/fiber";
import {
  Fisheye,
  CameraControls,
  PerspectiveCamera,
  Environment,
  Loader,
} from "@react-three/drei";
import { Level, Sudo, Camera, Cactus, Painting, Coin } from "../Scene";
import SongPreview from "../SongPreviewOverlay";

export default function ScenePage() {
  // The legacy scene CSS forces flex centering on every #root descendant.
  // We isolate that to this page only by toggling a class on <body>.
  useEffect(() => {
    document.body.classList.add("scene-active");
    return () => document.body.classList.remove("scene-active");
  }, []);

  return (
    <div
      className="scene-root fixed inset-0"
      style={{ background: "#090014" }}
    >
      <Canvas flat>
        <Fisheye zoom={0}>
          <CameraControls minPolarAngle={0} maxPolarAngle={Math.PI / 1.6} />
          <ambientLight intensity={Math.PI / 2} />
          <group scale={20} position={[5, -11, -5]}>
            <Level />
            <Sudo />
            <Camera />
            <Cactus />
            <Painting />
            <Coin />
          </group>
          <Environment preset="city" background blur={1} />
          <PerspectiveCamera makeDefault position={[0, 0, 18.5]} />
        </Fisheye>
      </Canvas>
      <SongPreview />
      <Loader />

      {/* HUD: back link + caption */}
      <div className="pointer-events-none fixed inset-x-0 top-0 z-50 flex items-start justify-between p-4 sm:p-6">
        <Link
          to="/"
          className="pointer-events-auto skew-btn"
          style={{ transform: "skewX(-12deg)" }}
        >
          <span>◂ Back to HQ</span>
        </Link>
        <div className="pointer-events-auto hidden items-center gap-3 border-2 border-mgfc-lime/70 bg-mgfc-bg/80 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.3em] text-mgfc-lime shadow-[0_0_20px_rgba(159,255,0,0.25)] sm:flex">
          <span className="h-2 w-2 animate-pulse rounded-full bg-mgfc-lime" />
          THE VOID // FAN-CLUB.OS v4.0
        </div>
      </div>
      <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 text-center">
        <p className="inline-block bg-mgfc-bg/70 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.4em] text-mgfc-cyan/80 backdrop-blur-sm">
          ▸ drag to look around &middot; click to interact
        </p>
      </div>
    </div>
  );
}
